<template>
  <Modal v-model="showModal" :title="showLang('com.op.edit.unit')" :mask-closable="false" width="1000px">
    <div class="edit-container">
      <Form ref="form" :model="form" :rules="rules" :label-width="80" class="form-area">
        <FormItem prop="name" :label="showLang('com.tab.title')">
          <Input ref="name" type="text" v-model="form.name" :placeholder="showLang('save.name')"></Input>
        </FormItem>
        <FormItem :label="showLang('work.contacts')">
          <Input ref="linkman" type="text" v-model="form.linkman" :placeholder="showLang('save.name')"></Input>
        </FormItem>
        <FormItem :label="showLang('com.site.phone')">
          <Input ref="mobile" type="text" v-model="form.mobile" :placeholder="showLang('save.name')"></Input>
        </FormItem>
        <FormItem :label-width="0">
          <vxe-table  :empty-text="showLang('com.data.no')" ref="userTable" border row-id="id" show-overflow show-header-overflow :data="users" :height="425" :row-config="{isHover: true}" :checkbox-config="{checkRowKeys: checkedKeys, highlight: true}" :key="refreshData">
            <vxe-column width="50" type="checkbox" field="id" fixed="left"></vxe-column>
            <vxe-column field="code" :title="showLang('com.login.name')" width="100"></vxe-column>
            <vxe-column field="name" :title="showLang('com.name')" width="100"></vxe-column>
            <vxe-column field="mobile" :title="showLang('com.site.phone')"></vxe-column>
          </vxe-table>
        </FormItem>
      </Form>
      <div class="tree-area" style="width: 300px;">
        <div class="tree-header">
          {{showLang('manage.nav.site.scope')}}：
        </div>
        <div class="tree-content">
          <Tree ref="groupTree" :data="groups" show-checkbox check-strictly @on-check-change="noceCheckChanged"></Tree>
        </div>
      </div>
      <div class="tree-area" style="width: 200px;">
        <div class="tree-header">
          {{showLang('work.support.dev.type')}}：
        </div>
        <div class="tree-content">
          <CheckboxGroup v-model="selectedParamTypes" class="chk-area">
            <template v-for="(item, idx) in types">
              <Checkbox v-if="item.tps.indexOf(appType) != -1" :label="item.id" :key="idx">
                <span>{{showLang(item.lang)}}</span>
              </Checkbox>
            </template>
          </CheckboxGroup>
        </div>
      </div>
    </div>
    <div slot="footer">
      <Button style="margin-right: 8px" @click="cancel">{{showLang('com.op.cancel')}}</Button>
      <Button type="primary" :loading="loading" @click="ok">{{showLang('com.op.save')}}</Button>
    </div>
  </Modal>
</template>
<script>
import { mapState,mapGetters } from 'vuex'
export default {
  name: 'ModalDefineEdit',
  components: {
  },
  model: {
    prop: 'value',
    event: 'showChanged'
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default() { return {}; }
    },
    forms: {
      type: Array,
      default() { return []; }
    },
    types: {
      type: Array,
      default() { return []; }
    }
  },
  data() {
    return {
      showModal: this.value,
      loading: false,
      isAdd: false,
      checkedKeys: [],
      selectedParamTypes: [],
      form: {
        id: 0,
        name: '',
        linkman: '',
        mobile: '',
        groups: [],
        users: [],
        paramTypes: [],
      },
      rules: {
        name: { required: true, type: 'string', min: 1, max: 50, message: '名称长度必须 1 - 50 个字符', trigger: 'blur' },
        formId: { required: true, type: 'number', min: 1, max: 50, message: '必须选择关联表单', trigger: 'on-change' },
      },
      allGroups: [],
      groups: [],
      users: [],
      refreshData: 0
    }
  },
  computed: {
    ...mapState('auth', ['appType']),
    ...mapGetters('auth', ['showLang','showLang'])
  },
  watch: {
    value(newVal) {
      this.showModal = newVal;
      if (newVal) {
        this.isAdd = this.item.isAdd;
        if (this.isAdd) {
          this.form.id = 0;
          this.form.name = '';
          this.form.linkman = '';
          this.form.mobile = '';
          this.form.groups = [];
          this.form.users = [];
          this.form.paramTypes = [];
          this.$set(this, "selectedParamTypes", []);
        } else {
          this.form.id = this.item.data.id;
          this.form.name = this.item.data.name;
          this.form.linkman = this.item.data.linkman;
          this.form.mobile = this.item.data.mobile;
          this.form.groups = this.item.data.groups;
          this.form.users = this.item.data.users;
          this.form.paramTypes = this.item.data.paramTypes;
          this.$set(this, "selectedParamTypes", this.form.paramTypes);
        }
        this.getGroups();
        this.getUsers();
      }
    },
    showModal(val) {
      this.$emit('showChanged', val);
    }
  },
  mounted: function () {
    this.rules.name.message=this.showLang('com.message.name.between',1,50);
    this.rules.formId.message=this.showLang('com.message.association.form');
  },
  methods: {
    itemCheck: function (val, item) {
      console.log('item check', val, item);
    },
    noceCheckChanged: function (nodes, node) {
      if (!node.checked) return;
      this.unchecksubs(node);
      for (let n of nodes) {
        if (this.isSub(node, n)) {
          this.$set(n, 'checked', false);
        }
      }
    },
    isSub: function (target, source) {
      if (target.id == source.id) return false;
      let issub = false;
      let pid = target.parentId;
      let running = true;
      while (running) {
        let pnodes = this.allGroups.filter(p => p.id == pid);
        if (pnodes.length == 0) break;
        let pnode = pnodes[0];
        if (pnode.id == source.id) {
          issub = true;
          break;
        } else {
          pid = pnode.parentId;
        }
      }
      return issub;
    },
    unchecksubs: function (node) {
      if (!node.children) return;
      for (let n of node.children) {
        this.$set(n, 'checked', false);
        this.unchecksubs(n);
      }
    },
    getUsers: function () {
      this.$axios.post(`sys/auth/QueryCustUser`, {}).then(res => {
        let uuus = res.data.map(p => { return { id: p.id, code: p.code, name: p.name, mobile: p.mobile }; });
        this.$set(this, 'users', uuus);
        var us = this.users.filter(p => this.form.users.indexOf(p.id) != -1);
        this.$refs.userTable.clearCheckboxRow()
        this.$refs.userTable.setCheckboxRow(us, true);
      })
    },
    getGroups: function () {
      this.$axios.post(`sys/auth/QueryGroupOld`, {}).then(res => {
        this.$set(this, 'allGroups', res.data.groups);
        if (res.data.roots.length == 0) {
          this.$set(this, 'groups', []);
        } else {
          let grpTree = [];
          for (let r of res.data.roots) {
            let grps = res.data.groups.filter(p => p.id == r);
            if (grps.length == 0) continue;
            let grp = grps[0];
            let node = { id: grp.id, parentId: grp.parentId, title: grp.name, checked: this.form.groups.indexOf(grp.id) != -1, expand: true, children: [] };
            this.initTreeData(node.children, res.data.groups, node.id)
            grpTree.push(node);
          }
          this.$set(this, 'groups', grpTree);
        }
      })
    },
    initTreeData: function (nodes, list, parent) {
      let subs = list.filter(p => p.parentId == parent);
      for (let grp of subs) {
        let node = { id: grp.id, parentId: grp.parentId, title: grp.name, checked: this.form.groups.indexOf(grp.id) != -1, expand: true, children: [] };
        this.initTreeData(node.children, list, grp.id);
        nodes.push(node);
      }
    },
    ok: async function () {
      let result = await this.$refs.form.validate();
      if (!result) {
        return;
      }
      let userGroups = [];
      let chkNodes = this.$refs.groupTree.getCheckedNodes();
      if (chkNodes.length == 0) {
        this.$Message.warning(this.showLang('save.Manage.scope'));
        return;
      } else {
        for (let cn of chkNodes) {
          userGroups.push(cn.id);
        }
      }
      let userNodes = this.$refs.userTable.getCheckboxRecords();
      let userIds = userNodes.map(p => p.id);
      if (userIds.length == 0) {
        this.$Message.warning(this.showLang('save.personnel.scope'));
        return;
      }
      if (this.selectedParamTypes.length == 0) {
        this.$Message.warning(this.showLang('save.support.dev.type'));
        return;
      }
      this.form.groups = userGroups;
      this.form.users = userIds;
      this.form.paramTypes = this.selectedParamTypes;
      this.loading = true;
      this.$axios.post(`//${this.domains.trans}/station/Maintance/SaveMaintanceOrgan`, this.form).then(res => {
        this.loading = false;
        if (res.code !== 0) {
          // this.$Message.error(res.data);
          return;
        }
        this.$Message.info(this.showLang('com.tips.save'));
        setTimeout(() => {
          this.showModal = false;
          this.$emit('saved', {});
        }, 800);
      })
    },
    cancel() {
      this.showModal = false;
    },
  }
}
</script>
<style scoped>
.edit-container {
  display: flex;
}
.form-area {
  /* border: solid 1px red; */
  width: 400px;
  /* height: 50px; */
  flex: auto;
}
.tree-area {
  border: solid 1px #dcdee2;
  border-radius: 6px;
  margin-left: 20px;
  width: 400px;
  flex: none;
  height: 600px;
  display: flex;
  flex-direction: column;
}
.tree-header {
  height: 40px;
  flex: none;
  border-bottom: solid 1px #dcdee2;
  display: flex;
  align-items: center;
  padding: 0 10px;
  font-size: 23px;
}
.tree-content {
  height: 40px;
  flex: auto;
  overflow: auto;
  padding: 0 10px;
}
.device-type-item {
  margin-top: 5px;
}
.chk-area {
  margin-top: 10px;
  display: flex;
  flex-direction: column;
}
</style>